import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button, Dropdown } from "react-bootstrap";

import BaseActionForm from '../BaseActionForm';

import './styles.scss'
import LeftPanelHeader from './../../components/LeftPanelHeader';

import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import * as actionTypes from "../../services/StoreContainer/actionTypes";

export default function Decomposer(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    return <DecomposerClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
    />
}

class DecomposerClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dataset: null,
            fields: null,
            selectedField: null,
            onErrorWithProcesses: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;
        this.handleDatasetSelect(dataset);
    }

    handleDatasetSelect = (dataset) => {
        let stringFields = [];
        if (dataset) {
            dataset.fields.forEach((field) => {
                if (field.type === "string") {
                    stringFields.push(field);
                }
            });
        }
        this.setState(
            {
                dataset: dataset,
                fields: stringFields,
                selectedField: null
            }, () => {
                if (dataset && checkActiveProcess(dataset, 'lk_decomposer')) {
                    this.setState({ onErrorWithProcesses: true })
                }
                this.datasetProcessCheck(dataset)
            }
        );
    }
    updateAndCheckDataset = (dataset) => {
        if (dataset) {
            this.lkApi.getDatasets().then((response) => {
                if (this.checkStatus(response)) {

                    response.datasets.forEach((newDataset) => {
                        if (newDataset._id === dataset._id) {
                            this.setState({
                                dataset: newDataset,
                                onErrorWithProcesses: checkActiveProcess(newDataset, 'lk_decomposer')
                            });
                        }
                    })
                }

                this.stopLoading();
            });
        }
    }
    datasetProcessCheck = (dataset) => {
        this.checkInterval && clearInterval(this.checkInterval);
        if (dataset) {
            this.checkInterval = setInterval(() => {
                this.startLoading();
                this.updateAndCheckDataset(dataset)
            }, 5000);
        }
    }

    handleFieldSelect = (field) => {
        this.setState({ selectedField: field });
    }

    onStartProcess = () => {
        if (this.state.dataset && !this.state.onErrorWithProcesses && this.state.selectedField) {
            this.lkApi.lKDecomposerTask(this.state.dataset.dataset, this.state.selectedField.name).then((response) => {
                this.setState({ processResult: response, onErrorWithProcesses: true });
                setTimeout(() => { this.setState({ processResult: null }) }, 5000);
            });
        }
    }

    render() {
        return (
            <div className='twoHalfs'>
                <div id={"decomposer"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.DECOMPOSER)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">
                        {this.state.fields && this.state.dataset &&
                            <>
                                <p className="textBottom">Bыберите поле для разбора адреса</p>
                                <Dropdown className="dropDecomposer">
                                    <Dropdown.Toggle className="dropdownButtonDecomposer" variant="success" id="dropdown-basic">
                                        {this.state.selectedField ? this.state.selectedField.caption : "Варианты разбора"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.fields.map((field, index) => (
                                            <Dropdown.Item key={index} onClick={() => { this.handleFieldSelect(field) }}>{field.caption}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                    </div>
                    {(this.state.processResult)
                        ?
                        <div className='textBottom'>
                            {(this.state.processResult.status === "success")
                                ?
                                <div>
                                    <p className='textBottom'>Запущен процесс разбора адреса</p>
                                </div>
                                :
                                <p className='textBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                            }
                        </div>
                        :
                        (this.state.dataset && this.state.selectedField) &&
                        <Button className='applyInstrument' style={this.state.onErrorWithProcesses ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>Запустить разбор адреса</Button>
                    }
                    <p className={'infoProcesses textBottom'} style={this.state.onErrorWithProcesses ? { display: 'inline' } : { display: 'none' }}> Дождитесь завершения запущенных процессов </p>

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}

